import './instrument'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import reportWebVitals from './reportWebVitals'
import './index.css'

import { PageLoadingOverlay } from './components'

const App = React.lazy(() => import('./main/App'))

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <React.Suspense
        fallback={<PageLoadingOverlay open={true} solid={true} />}
      >
        <App />
      </React.Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
